import { z } from "zod";
import { ZDate } from "./ZDate.js";
import { Interval } from "./common.js";
import { GroupedByTypeEnum } from "./fuel.js";
import { zArr, zNullable, zNum, zObj } from "./zodWrapper.js";
export const EsgPlantParams = zObj({
    lengthM: zNum(),
    widthM: zNum(),
    draftM: zNum(),
    cb: zNum(),
    dwtTonnes: zNum(),
    cfTonneCo2PerTonneFuel: zNum(),
});
export const EsgPlantParamsResponse = zObj({
    params: zNullable(EsgPlantParams),
});
export const EsgSetPlantParamsArgs = zObj({
    plantId: zNum(),
    params: EsgPlantParams,
});
export const EsgGetPlantParamsArgs = zObj({
    plantId: zNum(),
});
export const EsgGetIndexArgs = zObj({
    plantId: zNum(),
    interval: Interval,
    groupedBy: GroupedByTypeEnum,
    opModeId: zArr(zNum()),
});
export const IndexData = zObj({
    ref: ZDate,
    gramsCo2PerTonnesNauticalMiles: zNum(),
});
export const EsgIndexData = zObj({
    data: zNullable(zArr(IndexData)),
});
export const EsgGetRawDataArgs = z.object({
    plantId: zNum(),
    interval: Interval,
    opModeId: zArr(zNum()),
});
export const EsgRawDataOfDay = z.object({
    ref: ZDate,
    fuelConsumedTonnes: zNum(),
    distanceTraveledNM: zNum(),
    durationHours: zNum(),
    // avgDraftFwdM: zNullable(zNum()),
    // avgDraftAftM: zNullable(zNum()),
});
//# sourceMappingURL=esg.js.map